// extracted by mini-css-extract-plugin
module.exports = {"container":"_1pTf0w","suspend":"trIVQi _20Hql7 mz-button-primary _3kgFjJ mz-button-default _2W7kc0 _3gMFZ8 _2lZtnH _1DCWIx"};